/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

 export const FETCH_TRANSLATIONS = "FETCH_TRANSLATIONS";
 export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
 export const FETCH_UPCHARGE = "FETCH_UPCHARGE";
 export const SET_UPCHARGE = "SET_UPCHARGE";